import { useEffect, useRef, useState } from 'react'
import { Button, Container, FormSelect } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

import { useLocalStorage } from '../contexts/LocalStorageContext'
import { useSpeech } from '../contexts/SpeechContext'
import Swal from 'sweetalert2'

const Ocr = () => {
  const { addHistory, config } = useLocalStorage()
  const navigate = useNavigate()
  const { speak } = useSpeech()

  const videoRef = useRef()
  const canvasRef = useRef()

  const [localStream, setLocalStream] = useState(null)
  const [imageCapture, setImageCapture] = useState(null)

  const stop = () => {
    try {
      if (localStream) {
        localStream.getTracks().forEach((track) => track.stop())
      }
    } catch {}
  }

  const play = () => {
    stop()

    let constraints = {
      audio: false,
      video: {
        width: {
          ideal: 3840,
        },
        height: {
          ideal: 2160
        },
      },
    }

    if (config?.camera) {
      constraints.video.deviceId = config.camera
    } else {
      constraints.video.facingMode = {
        ideal: 'environment',
      }
    }

    navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
      setLocalStream(stream)
      videoRef.current.srcObject = stream

      if ('ImageCapture' in window) {
        const track = stream.getVideoTracks()
        if (track && track?.length > 0) {
          setImageCapture(new ImageCapture(track[0]))
        }
      }
    }).catch((err) => {
      console.error(err)
    })
  }

  const captureDocument = async () => {
    speak('Photographie du document en cours')

    const w = videoRef.current.videoWidth
    const h = videoRef.current.videoHeight
    canvasRef.current.width = w
    canvasRef.current.height = h

    const ctx = canvasRef.current.getContext('2d')
    ctx.drawImage(videoRef.current, 0, 0, w, h)
    const dataUrl = canvasRef.current.toDataURL("image/jpeg")

    Swal.fire({
      icon: 'info',
      title: 'Connexion au serveur en cours...',
      showConfirmButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    })

    const blob = await (await fetch(dataUrl)).blob()
    const formData = new FormData()
    formData.append('document', blob, 'photo.jpg')

    try {
      const response = await fetch('https://vocal-doc.rhyzom.dev/api/ocr', {
        method: 'POST',
        body: formData,
      })

      if (response.ok) {
        response.json()
            .then((data) => {
              if (data?.summary) {
              } else if (data?.content?.summary) {
                window.speechSynthesis.cancel()
                Swal.close()
                addHistory(data)
                navigate('/ocr-next', { state: { data } })
              } else {
                speak('Le document n\'a pas pu être lu')

                Swal.fire({
                  icon: 'error',
                  title: 'Le document n\'a pas pu être lu',
                }).then(() => {
                  navigate('/')
                })
              }
            })
      } else {
        speak('Problème de connexion avec le serveur, veuillez réessayer')

        Swal.fire({
          icon: 'error',
          title: 'Problème de connexion avec le serveur',
        })
      }
    } catch (err) {
      speak('Problème de connexion avec le serveur, veuillez réessayer')

      Swal.fire({
        icon: 'error',
        title: 'Problème de connexion avec le serveur',
      })
    }
  }

  useEffect(() => {
    if (config?.enableVoice) {
      speak('Appuyez sur le bouton bleu pour capturer le document')
    }

    const onLoad = async () => {
      const constraints = { video: true, audio: false }
      const stream = await navigator.mediaDevices.getUserMedia(constraints)

      const requestCameraPermission = async () => {
        const tracks = stream.getTracks()
        tracks.forEach((track) => track.stop())
      }

      await requestCameraPermission()
      play()
    }

    onLoad()

    return () => {
      stop()
    }
  }, [])

  return (
    <>
      <Container className="h-100">
        <div className="d-flex w-100 h-100 flex-column">
          <div className="d-flex align-items-center">
            <Button className="btn-success m-3" onClick={() => navigate('/')}>
              <i className="bi bi-house"> </i>
            </Button>
            <h1>Photographier</h1>
          </div>
          <video ref={videoRef} className="flex-grow-1" muted={true} autoPlay={true} playsInline={true}></video>
          <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>
          <img id="hiddenImg" style={{ display: 'none' }} alt="" />
          <div className="p-3">
            <Button className="btn-primary w-100" onClick={captureDocument}>
              <i className="bi bi-camera"> </i>
              Capturer le document
            </Button>
          </div>
        </div>
      </Container>
    </>
  )
}

export default Ocr
